import { React, useState, useEffect, useRef } from 'react'
import { motion } from "framer-motion";
import { useParams, } from "react-router-dom";
import { Helmet } from 'react-helmet'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo, faCirclePlus, faCircleMinus, faChevronLeft, faChevronRight, faChevronDown, faChevronUp, faUsers } from '@fortawesome/free-solid-svg-icons'

import MainHeader from '../../../components/MainHeader/MainHeader.js'
import MainFooter from '../../../components/MainFooter/MainFooter.js'
import Skeleton from '../../../components/Skeleton/Skeleton.js'
import CTAButton from '../../../components/CTAButton/CTAButton.js'
import DownloadButton from '../../../components/DownloadButton/DownloadButton.js'

import { boxvar2_1, boxvar4, URL_MAINAPI, API_TOKEN, formatScheduleDayWithWeekday, getAge, downloadPdf } from '../../../main.js'

import '../../../main.css'
import './ManageEventSchedulePlan.css'
import './MManageEventSchedulePlan.css'

import img_not_found from '../../../assets/pictures/imgnotfound.webp'


import Cookies from 'universal-cookie'

export default function ManageEventSchedulePlan() {

    const cookies = new Cookies()
    let cur_userid = cookies.get('userid')
    let cur_firstname = cookies.get('firstname')
    let cur_lastname = cookies.get('lastname')
    let cur_authtoken = cookies.get('authtoken')
    let loggedin = (cur_userid != "" && cur_userid != undefined)

    const { eventid } = useParams();
    var [loadedEventData, setLoadedEventData] = useState(0)
    var [loadedEventScheduleData, setLoadedEventScheduleData] = useState(0)
    var [loadedEventSchedulePlan, setLoadedEventSchedulePlan] = useState(0)
    var [noPlanYet, setNoPlanYet] = useState(0)
    var [resError, setResError] = useState("")


    var [formError, setFormError] = useState(false)

    var [scheduleFormData, setScheduleFormData] = useState({ a: 0 })

    var [eventData, setEventData] = useState({
        eventId: "",
        eventName: "",
        eventLongName: "Event wird geladen...",
        eventLogo: img_not_found,
        eventHeroImg: img_not_found,
        eventURL: "#",
        eventImprintURL: "#",
        eventOrganizator: "unbekannt",
        eventContactURL: "#",
        eventContactMail: "",
        eventContactTel: "",
        eventSlogan: "Mach mit!",
        eventApplicationActive: false,
        eventDates: {
            dateStart: "",
            dateEnd: "",
            applicationEnd: "",
            applicationStart: "",
        },
        eventStyle: {
            colorPrimary: '#662773',
            colorPrimaryGradient: '#986da0',
            colorSecondary: '#94b654',
            colorTileBg: '#f6deff',
            colorStdText: '#000000',
            colorBtnText: '#ffffff',
            colorStdTextOnTile: '#000000'
        },
        eventInfo: {
            box1Header: "Was ist das",
            box1Text: "Eventbeschreibung wird geladen...",
            box1HeroImg: null,
            box2Header: "Deine Aufgaben",
            box2Text1: "Aufgabenbeschreibung wird geladen...",
            box2Text2: "",
            box2CtaText: "Registrieren",
            box3Header: "Eckdaten",
            box3Contents: "",
            box3LookingFor: "",
            box3Text: "Weitere Fragen an den Veranstalter?",
            box3CtaText: "Kontakt"
        }
    })

    var [eventScheduleData, setEventScheduleData] = useState({
        eventId: "0",
        dates: [
            {
                day: "01.01.1900",
                schedules: [
                    {
                        scheduleElementId: "0",
                        title: "Beispiel",
                        startTime: "00:00",
                        endTime: "23:59",
                        description: "Beispielzeitraum",
                        location: "",
                        dutys: [
                            {
                                dutyId: "0",
                                title: "Beispieldienst",
                                description: "DIes ist ein Beispiel",
                                maxPersons: 0,
                                currentPersons: 0,
                                isFull: 0,
                                selection1: [],
                                selection2: []
                            },
                        ]
                    },
                ]
            },
        ]
    });

    var [eventSchedulePlan, setEventSchedulePlan] = useState({
        scheduleplan: { eventid: "0", dutys: [{ _id: "0", attendees: [] }] },
        attendeesdata: []
    })

    useEffect(() => {

        window.onbeforeunload = function () {
            // if (planChanged) {
            return "Willst du wirklich abbrechen? Du musst vorher absenden";
            // }
        };

        // setCur_userid(cookies.get('userid'))

        if (eventid == "0" || eventid == null) { } else {
            getEventData()
            getEventScheduleData()
            getEventSchedulePlan()
        }

        const listener = event => {

            if (event.code === "Enter" || event.code === "NumpadEnter") {
                // event.preventDefault()
            }
        }
        document.addEventListener("keydown", listener)
        return () => {
            document.removeEventListener("keydown", listener)
            if (duplicateHintTimeoutRef.current) {
                clearTimeout(duplicateHintTimeoutRef.current)
            }
        }


    }, [])


    function getEventData() {

        try {
            setLoadedEventData(0)

            fetch(URL_MAINAPI + "/event/" + eventid + "?ignoreinactive=1", {
                method: "GET",
                // mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
                // body: JSON.stringify(reqbody),

            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                // console.log(res.data)

                if (res.status == 200) {

                    setEventData(res.data)
                    setLoadedEventData(1)


                } else {
                    setEventData([])
                    setLoadedEventData(0)
                    setResError(res.data.error);

                }
            })
            )

        } catch (err) {
            setEventData([])
            setLoadedEventData(0)
            setResError(err);
        }

    }



    function getEventScheduleData() {
        try {
            setLoadedEventScheduleData(0)
            fetch(URL_MAINAPI + "/eventscheduleregister/listattendees/" + eventid, {
                method: "GET",
                // mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
                // body: JSON.stringify(reqbody),

            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                // console.log(res.data)

                if (res.status == 200) {
                    setLoadedEventScheduleData(1)
                    applyEventSchedulaData(res.data);

                    // lP('/eventmailverification/' + eventid + '?formVorname=' + formData.formVorname + '&formNachname=' + formData.formNachname);

                } else {
                    setLoadedEventScheduleData(0)
                    setResError(res.data.error);

                }
            })
            )

        } catch (err) {
            setLoadedEventScheduleData(0)
            setResError(err);

        }

    }


    function getEventSchedulePlan() {
        setNoPlanYet(0)

        try {
            setLoadedEventSchedulePlan(0)
            fetch(URL_MAINAPI + "/eventscheduleplan/" + eventid, {
                method: "GET",
                // mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
                // body: JSON.stringify(reqbody),

            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                console.log(res.data)

                if (res.status == 200) {
                    setLoadedEventSchedulePlan(1)
                    setEventSchedulePlan(res.data);
                    setPlanChanged(0)


                } else if (res.status == 404) {
                    setLoadedEventSchedulePlan(0)
                    setPlanChanged(0)
                    setNoPlanYet(1)

                } else {
                    setLoadedEventSchedulePlan(0)
                    setResError(res.data.error);

                }
            })
            )

        } catch (err) {
            setLoadedEventSchedulePlan(0)
            setResError(err);

        }

    }

    function applyEventSchedulaData(scheduledata) {
        // console.log(scheduledata.dates[0].day);
        setEventScheduleData({
            eventId: scheduledata.eventid,
            dates: scheduledata.dates
                .sort((a, b) => new Date(a.day.split('.').reverse().join('-')) - new Date(b.day.split('.').reverse().join('-'))) // Sortieren nach "YYYY-MM-DD" Format; Aufsteigend
                .map(date => ({
                    day: date.day,
                    schedules: date.schedules.map(schedule => ({
                        scheduleElementId: schedule._id,
                        title: schedule.title,
                        startTime: schedule.startTime,
                        endTime: schedule.endTime,
                        description: schedule.description,
                        location: schedule.location,
                        dutys: schedule.dutys.map(duty => ({
                            dutyId: duty._id,
                            title: duty.title,
                            description: duty.description,
                            maxPersons: duty.maxPersons,
                            currentPersons: duty.currentPersons,
                            isFull: duty.isFull,
                            selection1: duty.selection1_users,
                            selection2: duty.selection2_users
                            //DONE check for in backend
                            // currentPersons: 0,
                            // isFull: 0,
                        }))
                    }))
                }))
        });

    }

    var [isOpen, setIsOpen] = useState(0)
    function toggleDetails() {
        // Only schedule day <details>, not the explanation block
        const detailsElements = document.querySelectorAll('.schedule_date > details');
        const nextOpen = !isOpen;
        detailsElements.forEach(detail => {
            detail.open = nextOpen;
        });
        setIsOpen(nextOpen);
    };

    var [planChanged, setPlanChanged] = useState(0);
    var [duplicateHint, setDuplicateHint] = useState("");
    var [activeDrag, setActiveDrag] = useState(null);
    var [dragOverTarget, setDragOverTarget] = useState(null);
    var [userRailOpen, setUserRailOpen] = useState(false);
    var [foundUsers, setFoundUsers] = useState([]);
    var [userQuery, setUserQuery] = useState('');
    var [scheduleSearchQuery, setScheduleSearchQuery] = useState('');
    const duplicateHintTimeoutRef = useRef(null);
    const DRAG_TYPE_SCHEDULE_USER = "application/x-helferzeit-schedule-user";
    const DROP_ZONE_PLANNED = "planned";
    const DROP_ZONE_SELECTION1 = "selection1";
    const DROP_ZONE_SELECTION2 = "selection2";
    const DROP_ZONE_POOL = "pool";

    function buildDutyContextById() {
        const map = {};
        (eventScheduleData.dates || []).forEach(date => {
            (date.schedules || []).forEach(schedule => {
                (schedule.dutys || []).forEach(duty => {
                    map[String(duty.dutyId)] = {
                        day: date.day,
                        startTime: schedule.startTime,
                        endTime: schedule.endTime,
                        dutyTitle: duty.title
                    };
                });
            });
        });
        return map;
    }

    function findDuplicateConflicts(dutyid, userid) {
        const dutyContextById = buildDutyContextById();
        const target = dutyContextById[String(dutyid)];
        if (!target) return [];

        const conflicts = [];
        (eventSchedulePlan.scheduleplan.dutys || []).forEach(duty => {
            if (String(duty._id) === String(dutyid)) return;
            if (!(duty.attendees || []).some(attendee => String(attendee) === String(userid))) return;

            const ctx = dutyContextById[String(duty._id)];
            if (!ctx || ctx.day !== target.day) return;

            const sameSlot = ctx.startTime === target.startTime && ctx.endTime === target.endTime;
            conflicts.push({
                type: sameSlot ? "sameSlot" : "sameDay",
                day: ctx.day,
                startTime: ctx.startTime,
                endTime: ctx.endTime,
                dutyTitle: ctx.dutyTitle
            });
        });
        return conflicts;
    }

    function getUserDisplayName(userid) {
        const user = (eventSchedulePlan.attendeesdata || []).find(attendee => String(attendee._id) === String(userid));
        if (user) return `${user.firstname} ${user.lastname}`;
        return "Dieser Nutzer";
    }

    function formatConflictHint(userid, conflicts) {
        if (!conflicts.length) return "";

        const name = getUserDisplayName(userid);
        const slotConflicts = conflicts.filter(c => c.type === "sameSlot");
        const dayConflicts = conflicts.filter(c => c.type === "sameDay");
        const parts = [];

        if (slotConflicts.length) {
            const places = slotConflicts.map(c => c.dutyTitle).join(", ");
            parts.push(`${name} ist in diesem Zeitslot bereits eingeplant (${places})`);
        }
        if (dayConflicts.length) {
            const places = dayConflicts.map(c => `${c.dutyTitle}, ${c.startTime}–${c.endTime}`).join("; ");
            parts.push(`${name} ist an diesem Tag bereits eingeplant (${places})`);
        }

        return "Hinweis: " + parts.join(". ") + ".";
    }

    function showDuplicateHint(message) {
        if (!message) return;
        setDuplicateHint(message);
        if (duplicateHintTimeoutRef.current) {
            clearTimeout(duplicateHintTimeoutRef.current);
        }
        duplicateHintTimeoutRef.current = setTimeout(() => {
            setDuplicateHint("");
            duplicateHintTimeoutRef.current = null;
        }, 5000);
    }

    function isUserInDutyAttendees(attendees, userid) {
        return (attendees || []).some(attendee => String(attendee) === String(userid));
    }

    function addToDuty(dutyid, userid) {
        const targetDuty = (eventSchedulePlan.scheduleplan.dutys || []).find(duty => String(duty._id) === String(dutyid));
        const alreadyInDuty = targetDuty && isUserInDutyAttendees(targetDuty.attendees, userid);

        if (!alreadyInDuty) {
            const conflicts = findDuplicateConflicts(dutyid, userid);
            const hint = formatConflictHint(userid, conflicts);
            if (hint) showDuplicateHint(hint);
        }

        setPlanChanged(1);
        setEventSchedulePlan(prevState => {
            const dutyExists = prevState.scheduleplan.dutys.some(duty => String(duty._id) === String(dutyid));

            return {
                ...prevState,
                scheduleplan: {
                    ...prevState.scheduleplan,
                    dutys: dutyExists
                        ? prevState.scheduleplan.dutys.map(duty => {
                            if (String(duty._id) === String(dutyid)) {
                                // Only add user when not already in the array
                                if (!isUserInDutyAttendees(duty.attendees, userid)) {
                                    return { ...duty, attendees: [...duty.attendees, userid] };
                                }
                            }
                            return duty;
                        })
                        : [...prevState.scheduleplan.dutys, { _id: dutyid, attendees: [userid] }] // FIX: Add new duty with user for example when schedule was changed and new duty added
                }
            };
        });
    }

    function addAllToDuty(dutyid, users) {
        const targetDuty = (eventSchedulePlan.scheduleplan.dutys || []).find(duty => String(duty._id) === String(dutyid));
        const existingAttendees = targetDuty?.attendees || [];
        const newUsers = (users || []).filter(user => !isUserInDutyAttendees(existingAttendees, user.userid));

        const hintParts = [];
        newUsers.forEach(user => {
            const conflicts = findDuplicateConflicts(dutyid, user.userid);
            const hint = formatConflictHint(user.userid, conflicts);
            if (hint) hintParts.push(hint.replace(/^Hinweis:\s*/, ""));
        });
        if (hintParts.length) {
            showDuplicateHint("Hinweis: " + hintParts.join(" "));
        }

        setPlanChanged(1)

        setEventSchedulePlan(prevState => ({
            ...prevState,
            scheduleplan: {
                ...prevState.scheduleplan,
                dutys: prevState.scheduleplan.dutys.map(duty => {
                    if (String(duty._id) === String(dutyid)) {
                        const newAttendees = users
                            .map(user => user.userid)
                            .filter(userid => !isUserInDutyAttendees(duty.attendees, userid));

                        return { ...duty, attendees: [...duty.attendees, ...newAttendees] };
                    }
                    return duty;
                })
            }
        }));
    }

    function removeFromDuty(dutyid, userid) {
        setPlanChanged(1)

        setEventSchedulePlan(prevState => ({
            ...prevState,
            scheduleplan: {
                ...prevState.scheduleplan,
                dutys: prevState.scheduleplan.dutys.map(duty =>
                    String(duty._id) === String(dutyid)
                        ? { ...duty, attendees: duty.attendees.filter(attendee => String(attendee) !== String(userid)) }
                        : duty
                )
            }
        }));
    }

    function findDutyElement(dutyid) {
        for (const date of (eventScheduleData.dates || [])) {
            for (const schedule of (date.schedules || [])) {
                for (const duty of (schedule.dutys || [])) {
                    if (String(duty.dutyId) === String(dutyid)) return duty;
                }
            }
        }
        return null;
    }

    function isUserInSelectionList(users, userid) {
        return (users || []).some(user => {
            const id = user.userid || user.userdata?._id;
            return String(id) === String(userid);
        });
    }

    function getUserOriginForDuty(dutyid, userid) {
        const duty = findDutyElement(dutyid);
        if (!duty) return null;
        if (isUserInSelectionList(duty.selection1, userid)) return DROP_ZONE_SELECTION1;
        if (isUserInSelectionList(duty.selection2, userid)) return DROP_ZONE_SELECTION2;
        return null;
    }

    function isValidSelectionDrop(dutyid, zone, drag) {
        if (!drag || drag.sourceZone !== DROP_ZONE_PLANNED) return false;
        if (String(drag.sourceDutyId) !== String(dutyid)) return false;
        return getUserOriginForDuty(dutyid, drag.userid) === zone;
    }

    function isUserAlreadyInDuty(dutyid, userid) {
        const duty = (eventSchedulePlan.scheduleplan.dutys || []).find(d => String(d._id) === String(dutyid));
        return !!(duty && isUserInDutyAttendees(duty.attendees, userid));
    }

    function isDragOver(dutyid, zone) {
        return dragOverTarget
            && String(dragOverTarget.dutyId) === String(dutyid)
            && dragOverTarget.zone === zone;
    }

    function getDropzoneClassName(dutyid, zone) {
        const classes = ['scheduleplan_dropzone'];
        if (zone === DROP_ZONE_PLANNED) {
            classes.push('scheduleplan_planned_dropzone');
        } else {
            classes.push('scheduleplan_selection_dropzone');
        }

        const draggingFromPlanned = activeDrag?.sourceZone === DROP_ZONE_PLANNED;
        const alreadyInDuty = activeDrag && isUserAlreadyInDuty(dutyid, activeDrag.userid);
        const isSourceDuty = draggingFromPlanned && String(activeDrag.sourceDutyId) === String(dutyid);
        const draggingToPlan = activeDrag && (
            activeDrag.sourceZone === DROP_ZONE_SELECTION1
            || activeDrag.sourceZone === DROP_ZONE_SELECTION2
            || activeDrag.sourceZone === DROP_ZONE_POOL
            || (draggingFromPlanned && !isSourceDuty)
        );

        if (zone === DROP_ZONE_PLANNED && activeDrag) {
            if (alreadyInDuty || isSourceDuty) {
                classes.push('scheduleplan_dropzone_occupied');
            } else if (draggingToPlan) {
                classes.push('scheduleplan_dropzone_valid');
            }
        }

        if ((zone === DROP_ZONE_SELECTION1 || zone === DROP_ZONE_SELECTION2) && draggingFromPlanned) {
            if (isValidSelectionDrop(dutyid, zone, activeDrag)) {
                classes.push('scheduleplan_dropzone_valid');
            } else if (String(activeDrag.sourceDutyId) === String(dutyid)) {
                classes.push('scheduleplan_dropzone_disabled');
            }
        }

        if (isDragOver(dutyid, zone)) {
            classes.push('scheduleplan_dropzone_active');
        }

        return classes.join(' ');
    }

    function moveUserToDuty(targetDutyId, userid, sourceDutyId) {
        if (!userid || !targetDutyId) return;
        if (sourceDutyId && String(sourceDutyId) === String(targetDutyId)) return;

        const targetDuty = (eventSchedulePlan.scheduleplan.dutys || []).find(duty => String(duty._id) === String(targetDutyId));
        const alreadyInTarget = targetDuty && isUserInDutyAttendees(targetDuty.attendees, userid);

        if (alreadyInTarget) {
            if (sourceDutyId) {
                removeFromDuty(sourceDutyId, userid);
            }
            return;
        }

        if (!sourceDutyId) {
            addToDuty(targetDutyId, userid);
            return;
        }

        const conflicts = findDuplicateConflicts(targetDutyId, userid);
        const hint = formatConflictHint(userid, conflicts);
        if (hint) showDuplicateHint(hint);

        setPlanChanged(1);
        setEventSchedulePlan(prevState => {
            const dutyExists = prevState.scheduleplan.dutys.some(duty => String(duty._id) === String(targetDutyId));
            const dutys = prevState.scheduleplan.dutys.map(duty => {
                if (String(duty._id) === String(sourceDutyId)) {
                    return { ...duty, attendees: duty.attendees.filter(attendee => String(attendee) !== String(userid)) };
                }
                if (String(duty._id) === String(targetDutyId)) {
                    if (isUserInDutyAttendees(duty.attendees, userid)) return duty;
                    return { ...duty, attendees: [...duty.attendees, userid] };
                }
                return duty;
            });

            return {
                ...prevState,
                scheduleplan: {
                    ...prevState.scheduleplan,
                    dutys: dutyExists
                        ? dutys
                        : [...dutys, { _id: targetDutyId, attendees: [userid] }]
                }
            };
        });
    }

    function onUserDragStart(e, userid, sourceDutyId, sourceZone) {
        const payload = {
            userid: String(userid),
            sourceDutyId: sourceDutyId != null ? String(sourceDutyId) : null,
            sourceZone: sourceZone || (sourceDutyId != null ? DROP_ZONE_PLANNED : null)
        };
        e.dataTransfer.setData(DRAG_TYPE_SCHEDULE_USER, JSON.stringify(payload));
        e.dataTransfer.setData("text/plain", JSON.stringify(payload));
        e.dataTransfer.effectAllowed = sourceDutyId != null ? "move" : "copy";
        setActiveDrag(payload);
        setDragOverTarget(null);
    }

    function onUserDragEnd() {
        setActiveDrag(null);
        setDragOverTarget(null);
    }

    function onDutyDragOver(e, dutyid) {
        e.preventDefault();
        const occupied = activeDrag && isUserAlreadyInDuty(dutyid, activeDrag.userid);
        e.dataTransfer.dropEffect = occupied
            ? "none"
            : (e.dataTransfer.effectAllowed === "move" ? "move" : "copy");
        if (!isDragOver(dutyid, DROP_ZONE_PLANNED)) {
            setDragOverTarget({ dutyId: dutyid, zone: DROP_ZONE_PLANNED });
        }
    }

    function onDutyDragLeave(e, dutyid) {
        if (!e.currentTarget.contains(e.relatedTarget)) {
            if (isDragOver(dutyid, DROP_ZONE_PLANNED)) {
                setDragOverTarget(null);
            }
        }
    }

    function onDutyDrop(e, dutyid) {
        e.preventDefault();
        setDragOverTarget(null);
        setActiveDrag(null);

        const raw = e.dataTransfer.getData(DRAG_TYPE_SCHEDULE_USER) || e.dataTransfer.getData("text/plain");
        if (!raw) return;

        try {
            const data = JSON.parse(raw);
            if (!data?.userid) return;
            moveUserToDuty(dutyid, data.userid, data.sourceDutyId || null);
        } catch (err) {
            console.error("Ungültige Drag-Daten:", err);
        }
    }

    function onSelectionDragOver(e, dutyid, zone) {
        if (!isValidSelectionDrop(dutyid, zone, activeDrag)) return;
        e.preventDefault();
        e.dataTransfer.dropEffect = "move";
        if (!isDragOver(dutyid, zone)) {
            setDragOverTarget({ dutyId: dutyid, zone });
        }
    }

    function onSelectionDragLeave(e, dutyid, zone) {
        if (!e.currentTarget.contains(e.relatedTarget)) {
            if (isDragOver(dutyid, zone)) {
                setDragOverTarget(null);
            }
        }
    }

    function onSelectionDrop(e, dutyid, zone) {
        e.preventDefault();
        setDragOverTarget(null);

        const raw = e.dataTransfer.getData(DRAG_TYPE_SCHEDULE_USER) || e.dataTransfer.getData("text/plain");
        setActiveDrag(null);
        if (!raw) return;

        try {
            const data = JSON.parse(raw);
            if (!data?.userid) return;
            if (!isValidSelectionDrop(dutyid, zone, {
                userid: data.userid,
                sourceDutyId: data.sourceDutyId,
                sourceZone: data.sourceZone || DROP_ZONE_PLANNED
            })) return;
            removeFromDuty(dutyid, data.userid);
        } catch (err) {
            console.error("Ungültige Drag-Daten:", err);
        }
    }

    function canUnplanToPool(drag) {
        return !!(drag && drag.sourceZone === DROP_ZONE_PLANNED && drag.sourceDutyId);
    }

    function getPoolDropzoneClassName() {
        const classes = ['scheduleplan_userrail'];
        if (userRailOpen) classes.push('scheduleplan_userrail_open');
        if (canUnplanToPool(activeDrag)) {
            classes.push('scheduleplan_userrail_dropready');
        }
        if (isDragOver('pool', DROP_ZONE_POOL)) {
            classes.push('scheduleplan_userrail_dropactive');
        }
        return classes.join(' ');
    }

    function onPoolDragOver(e) {
        if (!canUnplanToPool(activeDrag)) return;
        e.preventDefault();
        e.dataTransfer.dropEffect = "move";
        if (!isDragOver('pool', DROP_ZONE_POOL)) {
            setDragOverTarget({ dutyId: 'pool', zone: DROP_ZONE_POOL });
        }
    }

    function onPoolDragLeave(e) {
        if (!e.currentTarget.contains(e.relatedTarget)) {
            if (isDragOver('pool', DROP_ZONE_POOL)) {
                setDragOverTarget(null);
            }
        }
    }

    function onPoolDrop(e) {
        e.preventDefault();
        setDragOverTarget(null);

        const raw = e.dataTransfer.getData(DRAG_TYPE_SCHEDULE_USER) || e.dataTransfer.getData("text/plain");
        setActiveDrag(null);
        if (!raw) return;

        try {
            const data = JSON.parse(raw);
            if (!canUnplanToPool({
                userid: data.userid,
                sourceDutyId: data.sourceDutyId,
                sourceZone: data.sourceZone || DROP_ZONE_PLANNED
            })) return;
            removeFromDuty(data.sourceDutyId, data.userid);
        } catch (err) {
            console.error("Ungültige Drag-Daten:", err);
        }
    }

    function countUserOccurrences(userid) {
        return eventSchedulePlan.scheduleplan.dutys.reduce((count, duty) =>
            count + (isUserInDutyAttendees(duty.attendees, userid) ? 1 : 0), 0
        );
    }

    function countRegisteredPersons(users) {
        return (users || []).reduce((sum, user) => {
            const companionsCount = Array.isArray(user.companions) ? user.companions.length : 0
            return sum + 1 + companionsCount
        }, 0)
    }

    function countPlannedPersons(attendeeIds) {
        return (attendeeIds || []).reduce((sum, userid) => {
            return sum + 1 + getCompanionsForUser(userid).length
        }, 0)
    }

    function renderActionIcon(icon, title, onClick, variant) {
        return (
            <FontAwesomeIcon
                icon={icon}
                title={title}
                className={'scheduleplan_action_icon' + (variant ? ' scheduleplan_action_icon_' + variant : '')}
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onClick();
                }}
                onMouseDown={(e) => e.stopPropagation()}
            />
        );
    }

    function renderCompanionRows(companions, keyPrefix, broughtByName, extraClassName) {
        if (!companions || !companions.length) return null;

        return (
            <div className={'scheduleplan_companions' + (extraClassName ? ' ' + extraClassName : '')}>
                {companions.map(function (companion, index) {
                    return (
                        <div
                            key={keyPrefix + '_' + index}
                            className="scheduleplan_companion"
                            title={broughtByName ? ('Mitgebracht von ' + broughtByName) : ''}
                        >
                            ↳ {companion.firstname} {companion.lastname}
                        </div>
                    )
                })}
            </div>
        )
    }

    function renderRegisteredUserBlock(user, dutyelement, dutyattendees, sourceZone) {
        const companions = Array.isArray(user.companions) ? user.companions : []
        const isUserPlanned = dutyattendees?.attendees.find(attendee => String(attendee) === String(user.userdata._id))
        const companionLabel = companions.length > 0 ? ` (+${companions.length})` : ''
        const userid = user.userdata._id
        const broughtByName = user.userdata.firstname + ' ' + user.userdata.lastname

        return (
            <div key={'reg_' + userid} className='scheduleplan_registered_block'>
                <div
                    className={'scheduleplan_userlistelement scheduleplan_userlistelement_draggable' + ((isUserPlanned != undefined) ? ' scheduleplan_userlistelement_isplanned' : '')}
                    draggable={true}
                    onDragStart={(e) => onUserDragStart(e, userid, null, sourceZone)}
                    onDragEnd={onUserDragEnd}
                    title={'' + user.userdata.contact.email + ' - ' + user.userdata.address.city}
                >
                    <span className='scheduleplan_userlistelement_label'>
                        {broughtByName}{companionLabel} ({getAge(user.userdata.birthday)}) x{countUserOccurrences(userid)}
                    </span>
                    <span className='scheduleplan_userlistelement_icons'>
                        {renderRemarkInfoIcon(getScheduleRemarkForUser(userid) || user.remark)}
                        {(isUserPlanned == undefined) ? renderActionIcon(faCirclePlus, 'Einplanen', () => addToDuty(dutyelement.dutyId, userid), 'add') : null}
                    </span>
                </div>
                {renderCompanionRows(companions, 'companion_' + userid, broughtByName)}
            </div>
        )
    }

    function buildScheduleRemarkByUserId() {
        const remarkByUserId = {};
        (eventScheduleData.dates || []).forEach(date => {
            (date.schedules || []).forEach(schedule => {
                (schedule.dutys || []).forEach(duty => {
                    [...(duty.selection1 || []), ...(duty.selection2 || [])].forEach(user => {
                        const remark = (user.remark || "").trim();
                        if (!remark) return;
                        const userid = String(user.userid || user.userdata?._id || "");
                        if (userid && !remarkByUserId[userid]) {
                            remarkByUserId[userid] = remark;
                        }
                    });
                });
            });
        });
        return remarkByUserId;
    }

    const scheduleRemarkByUserId = buildScheduleRemarkByUserId();

    function getScheduleRemarkForUser(userid) {
        return scheduleRemarkByUserId[String(userid)] || "";
    }

    function renderRemarkInfoIcon(remark) {
        if (!remark) return null;
        return (
            <FontAwesomeIcon
                icon={faCircleInfo}
                title={remark}
                className="scheduleplan_remark_icon"
                onClick={(e) => e.stopPropagation()}
            />
        );
    }

    function buildCompanionsByUserId() {
        const companionsByUserId = {};
        (eventScheduleData.dates || []).forEach(date => {
            (date.schedules || []).forEach(schedule => {
                (schedule.dutys || []).forEach(duty => {
                    [...(duty.selection1 || []), ...(duty.selection2 || [])].forEach(user => {
                        const userid = String(user.userid || user.userdata?._id || "");
                        const companions = Array.isArray(user.companions) ? user.companions : [];
                        if (userid && companions.length && !companionsByUserId[userid]) {
                            companionsByUserId[userid] = companions;
                        }
                    });
                });
            });
        });
        return companionsByUserId;
    }

    const companionsByUserId = buildCompanionsByUserId();

    function getCompanionsForUser(userid) {
        return companionsByUserId[String(userid)] || [];
    }

    function userMatchesSearchQuery(user, query) {
        const lowerQuery = (query || "").trim().toLowerCase();
        if (!lowerQuery) return true;

        const companions = getCompanionsForUser(user._id);
        const haystack = [
            user.firstname,
            user.lastname,
            user.contact?.email,
            user.address?.city,
            ...companions.map(companion => `${companion.firstname || ""} ${companion.lastname || ""}`)
        ].join(" ").toLowerCase();

        return haystack.includes(lowerQuery);
    }

    function getSidebarAttendees() {
        const users = [...(eventSchedulePlan.attendeesdata || [])];
        users.sort((a, b) => {
            const last = (a.lastname || "").localeCompare(b.lastname || "", "de");
            if (last !== 0) return last;
            return (a.firstname || "").localeCompare(b.firstname || "", "de");
        });
        if (!(userQuery || "").trim()) return users;
        return users.filter(user => userMatchesSearchQuery(user, userQuery));
    }

    let limitUserSearchResults = 15
    function searchUsers(users, query) {
        setFoundUsers([])

        if (query.length <= 2) {
            return
        }
        const lowerQuery = query.toLowerCase();

        var foundusers = users.filter(user => userMatchesSearchQuery(user, lowerQuery));
        // console.log("Found users", foundusers);
        setFoundUsers(foundusers.slice(0, limitUserSearchResults));
        //NOTE only shows top ten users
    }

    function handleUserSearchChange(query) {
        setUserQuery(query);
        searchUsers(eventSchedulePlan.attendeesdata, query);
    }

    function textMatchesScheduleSearch(text, query) {
        if (!query) return true;
        return String(text || "").toLowerCase().includes(query);
    }

    function getFilteredScheduleDates() {
        const query = (scheduleSearchQuery || "").trim().toLowerCase();
        const dates = eventScheduleData.dates || [];
        if (!query) return dates;

        return dates
            .map(date => {
                const dayMatches = textMatchesScheduleSearch(date.day, query);

                const filteredSchedules = (date.schedules || [])
                    .map(schedule => {
                        const scheduleHaystack = [
                            schedule.title,
                            schedule.description,
                            schedule.location,
                            schedule.startTime,
                            schedule.endTime,
                            `${schedule.startTime || ""}-${schedule.endTime || ""}`,
                            `${schedule.startTime || ""} - ${schedule.endTime || ""}`
                        ].join(" ");
                        const scheduleMatches = textMatchesScheduleSearch(scheduleHaystack, query);

                        if (dayMatches || scheduleMatches) {
                            return schedule;
                        }

                        const filteredDutys = (schedule.dutys || []).filter(duty =>
                            textMatchesScheduleSearch(duty.title, query) ||
                            textMatchesScheduleSearch(duty.description, query)
                        );

                        if (filteredDutys.length === 0) return null;
                        return { ...schedule, dutys: filteredDutys };
                    })
                    .filter(Boolean);

                if (filteredSchedules.length === 0) return null;
                return { ...date, schedules: filteredSchedules };
            })
            .filter(Boolean);
    }

    function addNewUser(dutyid, userid) {
        setUserQuery('')
        setFoundUsers([])
        addToDuty(dutyid, userid)

    }

    function resetChanges() {
        getEventSchedulePlan()
        setUserQuery('')
        setFoundUsers([])
    }

    function renderUserRail() {
        if (!loadedEventSchedulePlan) return null;

        const sidebarUsers = getSidebarAttendees();

        return (
            <aside
                className={getPoolDropzoneClassName()}
                aria-label="Angemeldete Helfer"
                onDragOver={onPoolDragOver}
                onDragLeave={onPoolDragLeave}
                onDrop={onPoolDrop}
            >
                <button
                    type="button"
                    className="scheduleplan_userrail_toggle"
                    onClick={() => setUserRailOpen(prev => !prev)}
                    title={userRailOpen ? "Helferleiste einklappen" : "Helferleiste ausklappen"}
                    aria-expanded={userRailOpen}
                    aria-label={userRailOpen ? "Helferleiste einklappen" : "Helferleiste ausklappen"}
                >
                    <FontAwesomeIcon icon={userRailOpen ? faChevronRight : faChevronLeft} className="scheduleplan_userrail_toggle_chevron" />
                    {!userRailOpen ? (
                        <>
                            <FontAwesomeIcon icon={faUsers} className="scheduleplan_userrail_toggle_icon" />
                            <span className="scheduleplan_userrail_toggle_text">Helfer</span>
                        </>
                    ) : null}
                </button>

                <div className="scheduleplan_userrail_panel">
                    <div className="scheduleplan_userrail_header">
                        <h3>Angemeldete Helfer</h3>
                        <span className="scheduleplan_userrail_count">{sidebarUsers.length}/{(eventSchedulePlan.attendeesdata || []).length}</span>
                    </div>
                    <input
                        className="scheduleplan_userrail_search"
                        placeholder="Nutzer suchen 🔎"
                        type="search"
                        value={userQuery}
                        onChange={(e) => handleUserSearchChange(e.target.value)}
                    />
                    <div className="scheduleplan_userrail_list">
                        {sidebarUsers.length === 0 ? (
                            <div className="scheduleplan_userrail_empty">
                                {(userQuery || "").trim() ? "Keine Treffer" : "Keine angemeldeten Helfer"}
                            </div>
                        ) : sidebarUsers.map(function (user) {
                            const companions = getCompanionsForUser(user._id);
                            const companionLabel = companions.length > 0 ? ` (+${companions.length})` : '';
                            const plannedCount = countUserOccurrences(user._id);
                            const broughtByName = user.firstname + ' ' + user.lastname;

                            return (
                                <div key={'rail_' + user._id} className="scheduleplan_userrail_block">
                                    <div
                                        className={'scheduleplan_userlistelement scheduleplan_userlistelement_draggable scheduleplan_userrail_item' + (plannedCount > 0 ? ' scheduleplan_userlistelement_isplanned' : '')}
                                        draggable={true}
                                        onDragStart={(e) => onUserDragStart(e, user._id, null, DROP_ZONE_POOL)}
                                        onDragEnd={onUserDragEnd}
                                        title={(user.contact?.email || '') + (user.address?.city ? ' - ' + user.address.city : '')}
                                    >
                                        <span className="scheduleplan_userlistelement_label">
                                            {broughtByName}{companionLabel} ({getAge(user.birthday)}) x{plannedCount}
                                        </span>
                                        <span className="scheduleplan_userlistelement_icons">
                                            {renderRemarkInfoIcon(getScheduleRemarkForUser(user._id))}
                                        </span>
                                    </div>
                                    {renderCompanionRows(companions, 'rail_companion_' + user._id, broughtByName, 'scheduleplan_userrail_companions')}
                                </div>
                            );
                        })}
                    </div>
                    {canUnplanToPool(activeDrag) ? (
                        <div className="scheduleplan_userrail_drop_hint">Hierher ziehen zum Austragen</div>
                    ) : null}
                </div>
            </aside>
        );
    }


    function updateSchedulePlan() {

        try {

            if (!loadedEventSchedulePlan) { return }
            //TODO warnen wenn noch nicht geladen

            let reqbody = { dutys: eventSchedulePlan.scheduleplan.dutys }

            // setLoadedEventSchedulePlan(0)
            fetch(URL_MAINAPI + "/eventscheduleplan/" + eventid, {
                method: "PATCH",
                // mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
                body: JSON.stringify(reqbody),

            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                console.log(res.data)

                if (res.status == 200) {
                    // setLoadedEventSchedulePlan(1)
                    // setEventSchedulePlan(res.data);
                    setPlanChanged(0)
                    getEventSchedulePlan()
                    setIsOpen(false)

                } else {
                    // setLoadedEventSchedulePlan(0)
                    setResError(res.data.error);

                }
            })
            )

        } catch (err) {
            // setLoadedEventSchedulePlan(0)
            setResError(err);

        }

    }

    function createSchedulePlan() {

        try {

            let reqbody = { eventid: eventid }

            // setLoadedEventSchedulePlan(0)
            fetch(URL_MAINAPI + "/eventscheduleplan/create", {
                method: "POST",
                // mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
                body: JSON.stringify(reqbody),

            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                console.log(res.data)

                if (res.status == 200) {
                    setLoadedEventSchedulePlan(0)
                    setPlanChanged(0)
                    setIsOpen(false)

                    getEventData()
                    getEventScheduleData()
                    getEventSchedulePlan()

                } else {
                    // setLoadedEventSchedulePlan(0)
                    setResError(res.data.error);

                }
            })
            )

        } catch (err) {
            // setLoadedEventSchedulePlan(0)
            setResError(err);

        }

    }


    function getPdfDailySchedule() {
        return downloadPdf(
            "/mailing/getdailyscheduleplanpdf/" + eventid,
            'Tagesdienstplan_' + eventData.shortname + '.pdf',
            cur_authtoken
        )
    }

    const filteredScheduleDates = getFilteredScheduleDates();
    const hasScheduleSearch = !!(scheduleSearchQuery || "").trim();

    return (
        <div className='mainCon page' id='mainCon_registerschedule'>
            <MainHeader selectedsite={""} />
            <Helmet>
                <meta charSet="utf-8" />
                <title>Dienstplan verwalten</title>
                <meta property="og:title" content="Dienstplanverwaltung" />
                <meta property="og:description" content="Verwalte den Dienstplan für deine Veranstaltung" />
                <meta name="robots" content="noindex" />
            </Helmet>

            <main className={'page-body container section scheduleplan_main' + (loadedEventSchedulePlan ? ' scheduleplan_has_userrail' : '') + (userRailOpen ? ' scheduleplan_with_userrail' : '')} style={{ paddingTop: '36px' }}>

                <div className='breadcrumb'>
                    {eventData.orgid ? <><a href={'/manage/org/' + eventData.orgid}>{eventData.organization ? eventData.organization.name : 'Organisation'}</a><FontAwesomeIcon icon={faChevronRight} /></> : <><a href='/profil'>Profil</a><FontAwesomeIcon icon={faChevronRight} /></>}
                    {loadedEventData ? <><a href={'/manage/event/' + eventid}>{eventData.name || 'Event'}</a><FontAwesomeIcon icon={faChevronRight} /></> : null}
                    <span>Dienstplan</span>
                </div>

                <motion.h1
                    variants={boxvar4}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, margin: "-50px" }}
                    className='section-title'
                    style={{ marginBottom: '6px' }}
                >
                    🗓️ Dienstplan verwalten
                </motion.h1>
                {loadedEventData ? <p className='section-sub'>für <a href={"/manage/event/" + eventid}>{eventData.name}</a></p> : <Skeleton width="240px" />}

                {(eventData.active != 1) ? (
                    <div className='banner-info' style={{ background: 'var(--warn-soft)', color: 'var(--warn)', marginBottom: '16px', marginTop: '16px' }}>
                        ⚠️ Event ist inaktiv und für andere nicht aufrufbar!
                    </div>
                ) : null}

                {(duplicateHint) ? (
                    <div className="scheduleplan_duplicate_hint" role="status" aria-live="polite">
                        {duplicateHint}
                    </div>
                ) : null}

                <motion.div variants={boxvar2_1} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }} style={{ marginTop: '20px' }}>
                    <div className='card' style={{ padding: '24px 26px', marginBottom: '20px' }}>
                        <div className='scheduleplan-toolbar'>
                            <button
                                type='button'
                                className={'toggle-chip' + (isOpen ? ' toggle-chip-active' : '')}
                                aria-pressed={isOpen ? 'true' : 'false'}
                                title={(isOpen) ? "Alle Tage zuklappen" : "Alle Tage aufklappen"}
                                onClick={() => toggleDetails()}
                            >
                                <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
                                <span>{(isOpen) ? "Zuklappen" : "Aufklappen"}</span>
                            </button>

                            <DownloadButton title="Tagesübersicht herunterladen" onDownload={() => getPdfDailySchedule()} />

                            {(!noPlanYet && loadedEventData && loadedEventScheduleData && loadedEventSchedulePlan) ? (
                                <CTAButton variant="primary" hideArrow={planChanged ? false : true} title={(planChanged) ? "Speichern" : "Gespeichert"} onclick={() => updateSchedulePlan()} />
                            ) : null}

                            {(noPlanYet == 1) ? (
                                <CTAButton variant="primary" hideArrow={false} title="Erstellen" onclick={() => createSchedulePlan()} />
                            ) : null}
                        </div>

                        {(planChanged && !noPlanYet) ? (
                            <div className='schedule-changed-hint'>
                                Ungesicherte Änderungen! <button type='button' className='schedule-changed-hint-link' onClick={() => resetChanges()}>Klick zum Verwerfen</button>
                            </div>
                        ) : null}

                        {(resError != "") ? (
                            <div className='banner-info' style={{ background: 'var(--error-soft)', color: 'var(--error)', marginTop: '14px', textAlign: 'left' }}>
                                Fehler aufgetreten: {resError}
                            </div>
                        ) : null}

                        <details className="scheduleplan_explanation">
                            <summary><b>Erklärung</b></summary>
                            <p>
                                Du kannst alle Diensttage auf einmal "Aufklappen" oder einzeln mit Klick auf das Datum.<br />
                                Verwalte den Dienstplan per Drag &amp; Drop: Ziehe Teilnehmer aus „Registriert“ oder „Warteliste“ in die Liste „Eingeplant“, oder verschiebe bereits eingeplante Nutzer zwischen Diensten. Nutzer aus Registriert/Warteliste kannst du wieder dorthin zurückziehen (manuell über die Suche hinzugefügte nur per Minus austragen). Ein Nutzer kann in demselben Dienst nicht doppelt stehen.<br />
                                Alternativ kannst du über die kleinen Plus- bzw. Minus-Icons neben dem Namen einplanen oder austragen. Der Nutzername wird grün, wenn du ihn für einen Wunschdienst eingeplant hast.<br />
                                Wenn du einen anderen Nutzer hinzufügen möchtest, nutze die Helferleiste rechts (Desktop) oder die Suchleiste am Dienst und gib mind. 3 Buchstaben ein. Klicke anschließend das gewünschte Suchergebnis an bzw. ziehe den Nutzer per Drag &amp; Drop in „Eingeplant“.<br />
                                <b>Gruppenanmeldungen:</b> Helfer können weitere Personen ohne eigenen Account mitbringen. Diese erscheinen unter dem Hauptnutzer als „mitgebracht“ und zählen bei der Kapazität mit (`1 + Mitbringer`). Einplanbar ist nur der Hauptnutzer (Account).<br />
                                Reicht bei der Anmeldung der Platz für die ganze Gruppe bei einem Wunschdienst nicht, hängt das Verhalten von der Wartelisten-Einstellung ab:<br />
                                • <b>Warteliste aktiv:</b> Der Dienst landet für die Gruppe auf der Warteliste (sichtbar unter „Warteliste“).<br />
                                • <b>Warteliste deaktiviert:</b> Der Dienst wird abgewählt und erscheint weder unter „Registriert“ noch unter „Warteliste“. Wenn dadurch alle Wunschdienste wegfallen, bleibt die Schicht-Anmeldung trotzdem gespeichert — ggf. ohne wirksame Dienste. Der Helfer kann das nicht selbst erneut absenden und muss dich kontaktieren.<br />
                                Wichtig: Am Ende musst du unbedingt deine Änderungen speichern!
                            </p>
                        </details>

                        {(!noPlanYet && loadedEventData && loadedEventScheduleData && loadedEventSchedulePlan) ? (
                            <div className="scheduleplan_schedule_search_wrap">
                                <input
                                    className="scheduleplan_schedule_search"
                                    placeholder="Tag oder Dienst suchen 🔎"
                                    type="search"
                                    value={scheduleSearchQuery}
                                    onChange={(e) => setScheduleSearchQuery(e.target.value)}
                                    aria-label="Tag oder Dienst suchen"
                                />
                                {hasScheduleSearch ? (
                                    <span className="scheduleplan_schedule_search_hint">
                                        {filteredScheduleDates.length} Tag{filteredScheduleDates.length === 1 ? "" : "e"} gefunden
                                    </span>
                                ) : null}
                            </div>
                        ) : null}
                    </div>

                    <div className='schedule_dates_list'>
                        {/* Div Container Tage */}

                        {

                                    (noPlanYet) ? <></> : (!loadedEventData || !loadedEventScheduleData || !loadedEventSchedulePlan) ? <p>Pläne werden geladen...</p> :
                                        (hasScheduleSearch && filteredScheduleDates.length === 0) ? (
                                            <p className="scheduleplan_schedule_search_empty">Keine Tage oder Dienste gefunden</p>
                                        ) : filteredScheduleDates.map(function (scheduledates) {
                                            // console.log(scheduledates.schedules);

                                            return (

                                                <div className='schedule_date' key={'day_' + scheduledates.day}>
                                                    <details style={{ width: "100%" }} {...(hasScheduleSearch ? { open: true } : {})}>
                                                        <summary>
                                                            <b>📅 {formatScheduleDayWithWeekday(scheduledates.day)}</b>
                                                        </summary>
                                                        <div className='schedule_scheduleelement_list'>
                                                            {scheduledates.schedules.map(function (scheduleelement) {
                                                                return (
                                                                    <div className='schedule_scheduleelement scheduleplan_tile' key={'slot_' + scheduledates.day + '_' + scheduleelement.scheduleElementId}>
                                                                        <h4>🕞 {scheduleelement.startTime} - {scheduleelement.endTime} <br className='m_break' />→ {scheduleelement.title}</h4>
                                                                        <p className='schedule_scheduleelement_desc'>{scheduleelement.description}</p>
                                                                        <div className='schedule_dutys_list'>
                                                                            {scheduleelement.dutys.map(function (dutyelement) {
                                                                                // console.log('DUTY ELEMENT', dutyelement);

                                                                                let dutyattendees = eventSchedulePlan.scheduleplan.dutys.find(duty => duty._id == dutyelement.dutyId)
                                                                                console.log(dutyattendees?.attendees);

                                                                                let dutyAttendeesCount = countPlannedPersons(dutyattendees?.attendees);

                                                                                const dutyExists = eventSchedulePlan.scheduleplan.dutys.some(duty => duty._id === dutyelement.dutyId);

                                                                                return (
                                                                                    <div className={'scheduleplan_card'} key={'duty_' + dutyelement.dutyId}>
                                                                                        <h4 style={{ color: (dutyAttendeesCount >= dutyelement.maxPersons ? 'var(--ci_color_ok)' : 'inherit') }}>{(dutyAttendeesCount >= dutyelement.maxPersons) ? '✅ ' : ''}{dutyelement.title} {dutyExists ? "" : "🆕"} ({dutyAttendeesCount}/{dutyelement.maxPersons})</h4>
                                                                                        <div>

                                                                                            <input className={'scheduleplan_usersearch_input'} placeholder={'Neuen Nutzer suchen 🔎'} type="search" onChange={(e) => { handleUserSearchChange(e.target.value); }} value={userQuery} />

                                                                                            {(foundUsers.length > 0) ? <div className={'scheduleplan_usersearch_results'}>
                                                                                                <span>Suchergebnisse: {(foundUsers.length == limitUserSearchResults) ? " (max " + limitUserSearchResults + " Ergebnisse)" : ""}</span>
                                                                                                {
                                                                                                    foundUsers.map(function (user) {
                                                                                                        return (<div className={'scheduleplan_usersearch_resultelement'} onClick={() => { addNewUser(dutyelement.dutyId, user._id) }}>➡️ {user.firstname} {user.lastname} ({user.contact.email})</div>)
                                                                                                    })}
                                                                                            </div> : (userQuery.length > 0) ? <div>suchen...</div> : <div></div>}
                                                                                        </div>
                                                                                        <div
                                                                                            className={getDropzoneClassName(dutyelement.dutyId, DROP_ZONE_PLANNED)}
                                                                                            onDragOver={(e) => onDutyDragOver(e, dutyelement.dutyId)}
                                                                                            onDragLeave={(e) => onDutyDragLeave(e, dutyelement.dutyId)}
                                                                                            onDrop={(e) => onDutyDrop(e, dutyelement.dutyId)}
                                                                                        >
                                                                                            <b>Eingeplant</b>
                                                                                            {/* <span><br />-noch nicht verfügbar-<br /></span> */}

                                                                                            {
                                                                                                (dutyattendees?.attendees || null) ? dutyattendees.attendees.map(function (user) {
                                                                                                    // console.log("USER", user);


                                                                                                    let userdata = eventSchedulePlan.attendeesdata.find(attendee => attendee._id == user)
                                                                                                    // console.log(userdata);
                                                                                                    const userOrigin = getUserOriginForDuty(dutyelement.dutyId, user);

                                                                                                    if (userdata) {
                                                                                                        const plannedRemark = getScheduleRemarkForUser(user);
                                                                                                        const companions = getCompanionsForUser(user);
                                                                                                        const companionLabel = companions.length > 0 ? ` (+${companions.length})` : '';
                                                                                                        const broughtByName = userdata.firstname + ' ' + userdata.lastname;
                                                                                                        return (
                                                                                                            <div key={'planned_block_' + dutyelement.dutyId + '_' + user} className='scheduleplan_registered_block'>
                                                                                                                <div
                                                                                                                    className={'scheduleplan_userlistelement scheduleplan_userlistelement_plan scheduleplan_userlistelement_draggable' + (!userOrigin ? ' scheduleplan_userlistelement_manual' : '')}
                                                                                                                    draggable={true}
                                                                                                                    onDragStart={(e) => onUserDragStart(e, user, dutyelement.dutyId, DROP_ZONE_PLANNED)}
                                                                                                                    onDragEnd={onUserDragEnd}
                                                                                                                    title={'' + userdata.contact.email + ' - ' + userdata.address.city + (!userOrigin ? ' (manuell hinzugefügt)' : '')}
                                                                                                                >
                                                                                                                    <span className='scheduleplan_userlistelement_label'>
                                                                                                                        {broughtByName}{companionLabel} ({getAge(userdata.birthday)}) x{countUserOccurrences(user)}
                                                                                                                    </span>
                                                                                                                    <span className='scheduleplan_userlistelement_icons'>
                                                                                                                        {renderRemarkInfoIcon(plannedRemark)}
                                                                                                                        {renderActionIcon(faCircleMinus, 'Austragen', () => removeFromDuty(dutyelement.dutyId, user), 'remove')}
                                                                                                                    </span>
                                                                                                                </div>
                                                                                                                {renderCompanionRows(companions, 'planned_companion_' + dutyelement.dutyId + '_' + user, broughtByName)}
                                                                                                            </div>
                                                                                                        )
                                                                                                    } else {
                                                                                                        return (
                                                                                                            <div
                                                                                                                key={'planned_missing_' + dutyelement.dutyId + '_' + user}
                                                                                                                className={'scheduleplan_userlistelement scheduleplan_userlistelement_plan scheduleplan_userlistelement_draggable' + (!userOrigin ? ' scheduleplan_userlistelement_manual' : '')}
                                                                                                                style={{ color: "var(--ci_color_error)" }}
                                                                                                                draggable={true}
                                                                                                                onDragStart={(e) => onUserDragStart(e, user, dutyelement.dutyId, DROP_ZONE_PLANNED)}
                                                                                                                onDragEnd={onUserDragEnd}
                                                                                                            >
                                                                                                                <span className='scheduleplan_userlistelement_label'>
                                                                                                                    NOT FOUND - {user}
                                                                                                                </span>
                                                                                                                <span className='scheduleplan_userlistelement_icons'>
                                                                                                                    {renderActionIcon(faCircleMinus, 'Austragen', () => removeFromDuty(dutyelement.dutyId, user), 'remove')}
                                                                                                                </span>
                                                                                                            </div>
                                                                                                        )

                                                                                                    }
                                                                                                }) : null


                                                                                            }
                                                                                            {(!dutyattendees?.attendees?.length) ? <div className="scheduleplan_dropzone_hint">Nutzer hierher ziehen</div> : null}

                                                                                        </div>

                                                                                        <div
                                                                                            className={getDropzoneClassName(dutyelement.dutyId, DROP_ZONE_SELECTION1)}
                                                                                            onDragOver={(e) => onSelectionDragOver(e, dutyelement.dutyId, DROP_ZONE_SELECTION1)}
                                                                                            onDragLeave={(e) => onSelectionDragLeave(e, dutyelement.dutyId, DROP_ZONE_SELECTION1)}
                                                                                            onDrop={(e) => onSelectionDrop(e, dutyelement.dutyId, DROP_ZONE_SELECTION1)}
                                                                                        >
                                                                                            <b>Registriert ({countRegisteredPersons(dutyelement.selection1)}/{dutyelement.maxPersons}) <i style={{ cursor: "copy", color: "var(--ci_color_secondary)" }} onClick={() => { addAllToDuty(dutyelement.dutyId, dutyelement.selection1) }}>Alle übernehmen</i></b>
                                                                                            {
                                                                                                (dutyelement.selection1.length > 0) ?
                                                                                                    dutyelement.selection1.map(function (user) {
                                                                                                        return renderRegisteredUserBlock(user, dutyelement, dutyattendees, DROP_ZONE_SELECTION1);
                                                                                                    }) : <span className="scheduleplan_selection_empty">--</span>

                                                                                            }
                                                                                        </div>
                                                                                        <div
                                                                                            className={getDropzoneClassName(dutyelement.dutyId, DROP_ZONE_SELECTION2)}
                                                                                            onDragOver={(e) => onSelectionDragOver(e, dutyelement.dutyId, DROP_ZONE_SELECTION2)}
                                                                                            onDragLeave={(e) => onSelectionDragLeave(e, dutyelement.dutyId, DROP_ZONE_SELECTION2)}
                                                                                            onDrop={(e) => onSelectionDrop(e, dutyelement.dutyId, DROP_ZONE_SELECTION2)}
                                                                                        >
                                                                                            <b>Warteliste ({countRegisteredPersons(dutyelement.selection2)})</b>
                                                                                            {
                                                                                                (dutyelement.selection2.length > 0) ?
                                                                                                    dutyelement.selection2.map(function (user) {
                                                                                                        return renderRegisteredUserBlock(user, dutyelement, dutyattendees, DROP_ZONE_SELECTION2);
                                                                                                    }) : <span className="scheduleplan_selection_empty">--</span>
                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                );

                                                                            })}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </details>
                                                </div>
                                            );
                                        })
                                        }
                    </div>
                </motion.div>
            </main>

            {renderUserRail()}

            <MainFooter useEventStyle={false} />
        </div >
    )
}